module.exports = __webpack_public_path__ + "img/ic-uploaded.f4cf3853.svg";